import { TAttraction } from "../attractions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";
import { MEXICO_PROVINCES } from "_common/regions/regions";

export const yucatanAttraction: TAttraction[] = [
    {
        name: "Mérida International Airport (MID)",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9335705,
            lng: -89.6591792,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Mayan Train - Valladolid",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.7401,
            lng: -88.1958449,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Chichén Itzá",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.7212199,
            lng: -88.5536955,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Izamal",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9363,
            lng: -89.0877003,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train Tixkokob",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.98731,
            lng: -89.4019003,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Teya Mérida",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9293641,
            lng: -89.5175802,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Umán",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.84903,
            lng: -89.7574703,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Maxcanú",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.60254,
            lng: -89.9777503,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "ADO Caucel City",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.0503401,
            lng: -89.6796766,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Terminal de Autobuses de Merida TAME",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.0503401,
            lng: -89.6796766,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Terminal Alterna Paseo 60",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9834865,
            lng: -89.6197564,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Altabrisa",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.0147455,
            lng: -89.5842217,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Talleres",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9458232,
            lng: -89.7980663,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "Hospital Regional de Alta Especialidad de la Península de Yucatán",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.0192936,
            lng: -90.1422114,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "General Hospital Agustín O 'Horan",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9746488,
            lng: -89.6416204,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "CHRISTUS MUGUERZA Hospital Faro del Mayab",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.0437858,
            lng: -89.601767,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Star Medica Hospital",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.0162107,
            lng: -89.5850164,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Clinica de Merida",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9863061,
            lng: -89.638416,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "CMA Hospital",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9841462,
            lng: -89.6160661,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital General Regional Lic Ignacio Garcia Tellez IMSS",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9791897,
            lng: -89.6037366,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "IMSS Hospital Merida",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.9790242,
            lng: -89.6029737,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Unidad Medica UMED",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.5220049,
            lng: -87.3803051,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "General Hospital of Valladolid",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.6965616,
            lng: -88.2147728,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Cancunito",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.0395839,
            lng: -89.4831249,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Uaymitun",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.3135172,
            lng: -89.51282,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Chiburna Puerto",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.2495375,
            lng: -89.8440902,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Sisal",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.1652573,
            lng: -90.0402455,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Puerto Progresso",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.2769123,
            lng: -89.6670042,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Sisal",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.1675106,
            lng: -90.0316859,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa San Crisanto",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.3540823,
            lng: -89.1746124,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Publica San Crisanto",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.3545069,
            lng: -89.1704846,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Uaymitún",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.3167655,
            lng: -89.4928592,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Sur Celestún",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.8576172,
            lng: -90.4025838,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Norte Celestún",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.8610785,
            lng: -90.4009886,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Puerto Chelem",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.2713683,
            lng: -89.7426132,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa de San Felipe",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.57717,
            lng: -88.2320514,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Las Coloradas",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.6087422,
            lng: -87.9905884,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Chabihau",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.3565769,
            lng: -89.1179351,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa El Cuyo",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.5177629,
            lng: -87.6768868,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Dzilám",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.3933914,
            lng: -88.8942282,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Mompracem",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.3009567,
            lng: -89.5740509,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Manglar de San Crisanto",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.3508436,
            lng: -89.1716507,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Chucho",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.2652062,
            lng: -89.7711357,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Progresso",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 21.2875003,
            lng: -89.666528,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Kan Balam",
        region: MEXICO_PROVINCES.YUCATAN,
        coordinates: {
            lat: 20.8637556,
            lng: -90.3995117,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
];
